<template>
  <div class="flex justify-center">
    <img :src="merchantLogo ? merchantLogo : DefaultImage" class="layup-logo size-32 h-auto" />
  </div>
</template>

<script lang="ts" setup>
import DefaultImage from '@/assets/logo.svg';
import { useWidgetStore } from '@/stores/widget';
import { computed } from 'vue';

const widgetStore = useWidgetStore();
const merchantLogo = computed(() => {
  if (widgetStore.paymentPlanPreview?.customFeatures?.paymentWidget?.enabled) {
    return widgetStore.paymentPlanPreview.customFeatures.paymentWidget.value;
  }
  if (widgetStore.boost?.merchant?.customFeatures?.paymentWidget?.enabled) {
    return widgetStore.boost.merchant.customFeatures?.paymentWidget?.value;
  }

  return null;
});
</script>
